package br.com.vvrefeicoes.portal.feature.shell

import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.vector.ImageVector
import br.com.vvrefeicoes.portal.domain.model.PermissionKeys
import br.com.vvrefeicoes.portal.navigation.AdminAuditRoute
import br.com.vvrefeicoes.portal.navigation.AdminCompaniesRoute
import br.com.vvrefeicoes.portal.navigation.AdminUsersRoute
import br.com.vvrefeicoes.portal.navigation.AnnouncementsRoute
import br.com.vvrefeicoes.portal.navigation.CommercialRoute
import br.com.vvrefeicoes.portal.navigation.FoodPassBillingRoute
import br.com.vvrefeicoes.portal.navigation.FoodPassClientsRoute
import br.com.vvrefeicoes.portal.navigation.FoodPassConsumptionsRoute
import br.com.vvrefeicoes.portal.navigation.FormulariosRoute
import br.com.vvrefeicoes.portal.navigation.GuidesAndManualsRoute
import br.com.vvrefeicoes.portal.navigation.HomeRoute
import br.com.vvrefeicoes.portal.navigation.JuridicoEmpresasRoute
import br.com.vvrefeicoes.portal.navigation.JuridicoOfficersCourtsRoute
import br.com.vvrefeicoes.portal.navigation.NotificationsRoute
import br.com.vvrefeicoes.portal.navigation.OperationalEntriesRoute
import br.com.vvrefeicoes.portal.navigation.OperationalPanelRoute
import br.com.vvrefeicoes.portal.navigation.OrgChartRoute
import br.com.vvrefeicoes.portal.navigation.PurchasesEntriesRoute
import br.com.vvrefeicoes.portal.navigation.PurchasesRoute
import br.com.vvrefeicoes.portal.navigation.RhEntriesRoute
import br.com.vvrefeicoes.portal.navigation.RhPanelRoute
import br.com.vvrefeicoes.portal.navigation.RmpRoute
import br.com.vvrefeicoes.portal.navigation.RmpSyncRoute
import br.com.vvrefeicoes.portal.navigation.SatisfactionOperationStatusRoute
import br.com.vvrefeicoes.portal.navigation.SatisfactionReportsRoute
import br.com.vvrefeicoes.portal.navigation.SocialConnectionsRoute
import br.com.vvrefeicoes.portal.navigation.SystemHealthRoute
import com.composables.icons.lucide.BookOpen
import com.composables.icons.lucide.ChartColumn
import com.composables.icons.lucide.FileText
import com.composables.icons.lucide.Handshake
import com.composables.icons.lucide.House
import com.composables.icons.lucide.List
import com.composables.icons.lucide.Lucide
import com.composables.icons.lucide.Network
import com.composables.icons.lucide.PersonStanding
import com.composables.icons.lucide.ShieldUser
import com.composables.icons.lucide.ShoppingCart
import com.composables.icons.lucide.Users
import com.composables.icons.lucide.Utensils
import com.composables.icons.lucide.Wrench

data class ShellMenuItem(
    val label: String,
    val icon: ImageVector?,
    val route: Any? = null,
    val permission: String? = null,
    val children: List<ShellMenuItem> = emptyList(),
)

private val NonSectorMenuLabels = setOf("Administração", "Ferramentas", "Guias e manuais", "Organograma")

@Composable
fun shellMenuItems(): List<ShellMenuItem> =
    listOf(
        ShellMenuItem(
            label = "Início",
            icon = Lucide.House,
            route = HomeRoute,
        ),
        ShellMenuItem(
            label = "Administração",
            icon = Lucide.ShieldUser,
            children =
                listOf(
                    ShellMenuItem(
                        label = "Unidades",
                        icon = null,
                        route = AdminCompaniesRoute,
                        permission = PermissionKeys.COMPANIES,
                    ),
                    ShellMenuItem(
                        label = "Usuários",
                        icon = null,
                        route = AdminUsersRoute,
                        permission = PermissionKeys.USERS,
                    ),
                    ShellMenuItem(
                        label = "Auditoria",
                        icon = null,
                        route = AdminAuditRoute,
                        permission = PermissionKeys.AUDIT,
                    ),
                ),
        ),
        ShellMenuItem(
            label = "Operacional",
            icon = Lucide.ChartColumn,
            children =
                listOf(
                    ShellMenuItem(
                        label = "Painel",
                        icon = null,
                        route = OperationalPanelRoute,
                        permission = PermissionKeys.OPERATIONAL_PANEL,
                    ),
                    ShellMenuItem(
                        label = "Lançamentos",
                        icon = null,
                        route = OperationalEntriesRoute,
                        permission = PermissionKeys.OPERATIONAL_ENTRIES,
                    ),
                ),
        ),
        ShellMenuItem(
            label = "RH",
            icon = Lucide.PersonStanding,
            children =
                listOf(
                    ShellMenuItem(
                        label = "Painel",
                        icon = null,
                        route = RhPanelRoute,
                        permission = PermissionKeys.RH_PANEL,
                    ),
                    ShellMenuItem(
                        label = "Lançamentos",
                        icon = null,
                        route = RhEntriesRoute,
                        permission = PermissionKeys.RH_ENTRIES,
                    ),
                    ShellMenuItem(
                        label = "RMP",
                        icon = null,
                        route = RmpRoute,
                        permission = PermissionKeys.RMP,
                    ),
                    ShellMenuItem(
                        label = "Sync",
                        icon = null,
                        route = RmpSyncRoute,
                        permission = PermissionKeys.RMP_ADMIN,
                    ),
                ),
        ),
        ShellMenuItem(
            label = "Comercial",
            icon = Lucide.Handshake,
            children =
                listOf(
                    ShellMenuItem(
                        label = "Painel",
                        icon = null,
                        route = CommercialRoute,
                        permission = PermissionKeys.COMMERCIAL,
                    ),
                ),
        ),
        ShellMenuItem(
            label = "Compras",
            icon = Lucide.ShoppingCart,
            children =
                listOf(
                    ShellMenuItem(
                        label = "Painel",
                        icon = null,
                        route = PurchasesRoute,
                        permission = PermissionKeys.PURCHASES,
                    ),
                    ShellMenuItem(
                        label = "Lançamentos",
                        icon = null,
                        route = PurchasesEntriesRoute,
                        permission = PermissionKeys.PURCHASES_ENTRIES,
                    ),
                ),
        ),
        ShellMenuItem(
            label = "Organograma",
            icon = Lucide.Network,
            route = OrgChartRoute,
            permission = PermissionKeys.ORG_CHART,
        ),
        ShellMenuItem(
            label = "Ferramentas",
            icon = Lucide.Wrench,
            children =
                listOf(
                    ShellMenuItem(
                        label = "Food Pass",
                        icon = Lucide.Utensils,
                        permission = PermissionKeys.FOOD_PASS,
                        children =
                            listOf(
                                ShellMenuItem(
                                    label = "Clientes",
                                    icon = Lucide.Users,
                                    route = FoodPassClientsRoute,
                                    permission = PermissionKeys.FOOD_PASS,
                                ),
                                ShellMenuItem(
                                    label = "Consumos",
                                    icon = Lucide.List,
                                    route = FoodPassConsumptionsRoute,
                                    permission = PermissionKeys.FOOD_PASS,
                                ),
                                ShellMenuItem(
                                    label = "Faturamento",
                                    icon = Lucide.FileText,
                                    route = FoodPassBillingRoute,
                                    permission = PermissionKeys.FOOD_PASS,
                                ),
                            ),
                    ),
                    ShellMenuItem(
                        label = "Satisfaction",
                        icon = Lucide.ChartColumn,
                        permission = PermissionKeys.SATISFACTION,
                        children =
                            listOf(
                                ShellMenuItem(
                                    label = "Relatórios",
                                    icon = null,
                                    route = SatisfactionReportsRoute,
                                    permission = PermissionKeys.SATISFACTION,
                                ),
                                ShellMenuItem(
                                    label = "Status da Operação",
                                    icon = null,
                                    route = SatisfactionOperationStatusRoute,
                                    permission = PermissionKeys.SATISFACTION,
                                ),
                            ),
                    ),
                    ShellMenuItem(
                        label = "Redes sociais",
                        icon = Lucide.Network,
                        route = SocialConnectionsRoute,
                        permission = PermissionKeys.SOCIAL_CONNECTIONS,
                    ),
                    ShellMenuItem(label = "Notificações", icon = null, route = NotificationsRoute),
                    ShellMenuItem(
                        label = "Comunicados",
                        icon = null,
                        route = AnnouncementsRoute,
                        permission = PermissionKeys.ANNOUNCEMENTS,
                    ),
                    ShellMenuItem(
                        label = "Formulários",
                        icon = null,
                        route = FormulariosRoute,
                        permission = PermissionKeys.FORMULARIOS,
                    ),
                    ShellMenuItem(
                        label = "Saúde do sistema",
                        icon = null,
                        route = SystemHealthRoute,
                        permission = PermissionKeys.SYSTEM_HEALTH,
                    ),
                    ShellMenuItem(
                        label = "Empresas CNPJ",
                        icon = null,
                        route = JuridicoEmpresasRoute,
                        permission = PermissionKeys.CNPJ_EMPRESAS,
                    ),
                ),
        ),
        ShellMenuItem(
            label = "Jurídico",
            icon = Lucide.FileText,
            children =
                listOf(
                    ShellMenuItem(
                        label = "Oficiais e Tribunais",
                        icon = null,
                        route = JuridicoOfficersCourtsRoute,
                        permission = PermissionKeys.JURIDICO,
                    ),
                ),
        ),
        ShellMenuItem(
            label = "Guias e manuais",
            icon = Lucide.BookOpen,
            route = GuidesAndManualsRoute,
            permission = PermissionKeys.GUIDES_AND_MANUALS,
        ),
    ).map { it.copy(children = it.children.sortedAlphabetically()) }
        .sortedWith(
            compareBy(
                {
                    when {
                        it.label == "Início" -> 0
                        it.label in NonSectorMenuLabels -> 2
                        else -> 1
                    }
                },
                { it.label.lowercase() },
            ),
        )

private fun List<ShellMenuItem>.sortedAlphabetically(): List<ShellMenuItem> =
    map { it.copy(children = it.children.sortedAlphabetically()) }
        .sortedWith(compareBy({ it.label != "Painel" }, { it.label.lowercase() }))

fun List<ShellMenuItem>.visibleFor(permissions: Set<String>): List<ShellMenuItem> =
    mapNotNull { item ->
        if (item.children.isNotEmpty()) {
            val visibleChildren = item.children.visibleFor(permissions)
            if (visibleChildren.isEmpty()) null else item.copy(children = visibleChildren)
        } else if (item.permission == null || item.permission in permissions) {
            item
        } else {
            null
        }
    }
